<template>
    <transition name="fade">
        <div class="vue-modal" v-show="open">
            <transition name="drop-in">
                <div class="vue-modal-inner" v-show="open">
                    <div class="vue-modal-content">
                        <slot />
                        <p class="h3 text-seccess fw-bold" style="color: var(--theme-text-main);">Please Enter Return Reason</p>
                        
                        <textarea rows="6" type="text" v-on:keyup.enter="Void()" class="form-control" name="reason" id="reason" v-model="reason"/>
                        <br />
                        <table style="width:100%"> 
                            <tr> 
                                <td> 
                                </td> 
                                <td> 
                                    <button @click="Submit()" class="btn btn-success">Submit</button>
                                </td> 
                                <td> 
                                    <button @click="close" class="btn btn-danger">Close</button>                                    
                                </td> 
                                <td> 
                                </td> 
                                <td> 
                                </td> 
                            </tr> 
                        </table>
                    </div>
                </div>
            </transition>
        </div>
    </transition>
</template>
<script>

import axios from "axios";
import commonServices from "@/shared/commonServices"

export default {
    mixins: [commonServices],
    mounted() {
        this.$el.querySelector('#reason').focus = true;
    }, 

    data: function(){
        return {
            reason : '',

        }
    },
    methods:{
        Submit: async function(){
            this.$emit('getReason', this.reason);
            this.close();
        }
    },
    props:{
        open: {
            type:Boolean,
            required:true
        },
    },
    setup(_, { emit }){
        const close = () => {
            emit('close');
        };

        return { close };
    },
};
</script>
<style scoped>
*,
::before

::after{
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}
.vue-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    background-color: rgba(0, 0, 0, 0.4);
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1rem;
}
.vue-modal-inner {
    max-width: 100%;
    max-height: 50%;
    margin: 2rem auto;
}
.vue-modal-content {
    position: relative;
    background-color: var(--form-color);
    border: 5px solid rgba(0, 0, 0, 0.3);
    background-clip: padding-box;
    border-radius: 1rem;
    padding: 1rem;
    width: 500px;
    height: 100%;
}
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}
.drop-in-enter-active,
.drop-in-leave-active {
    transition: all 0.3s ease-out;
}
.drop-in-enter-from,
.drop-in-leave-to {
    opacity: 0;
    transform: translateY(50px);
}
</style>
